interface cookiesManagerEN {
  cookies_manager: string;
  cookies_manager_desc: string;
  cookies_first: string;
  cookies_button_accept: string;
  cookies_button_reject: string;
  cookies_clear_all: string;
  cookies_information: string;
}

export const cookiesManagerEN: cookiesManagerEN = {
  cookies_manager: "MANAGE COOKIES",
  cookies_manager_desc:
    "This page allows you to manage your cookie preferences and control the information we collect through cookies on our website. Adjusting these settings will help us deliver a better, more tailored experience while respecting your privacy choices.",
  cookies_first: "YouTube Cookies",
  cookies_button_accept: "Accept cookies",
  cookies_button_reject: "Reject cookies",
  cookies_clear_all: "Clear all cookies",
  cookies_information:
    "For more information on our cookie usage, please review our Cookies Policy.",
};
